import React, { useState } from 'react';
import './question.css';
import { Paragraph } from '../../../components/paragraph';
import { QuestionSelector } from './question-selector';
import { TextButton } from '../../../components/text-button';
import { Heading } from '../../../components/heading';

const Question = props => {
    const { question, submitResponse, modalVisible } = props;

    const [activeOption, setActiveOption] = useState(0);

    return (
        <div className="question">
            <Paragraph
                colorScheme="dark"
                withIndent={true}
                withSpacing={false}
                textAlign="center"
            >
                {question.notes}
            </Paragraph>
            <div className="question__recipient">
                <Heading
                    colorScheme="dark"
                    withIndent={true}
                    withSpacing={true}
                    headingType="h4"
                    size="medium"
                    textAlign="center"
                >
                    Question to the {question.title}
                </Heading>
            </div>
            <QuestionSelector
                modalVisible={modalVisible}
                options={question.questions}
                activeOption={activeOption}
                setActiveOption={setActiveOption}
            />
            <div className="question__footer">
                <TextButton
                    onClick={() => submitResponse(activeOption)}
                    text="Submit"
                    isDisabled={modalVisible}
                />
            </div>
        </div>
    );
};

export { Question };
